var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1539 2.1326V3.28961H2.41838C1.46023 3.28961 0.682861 4.06698 0.682861 5.02513V6.76065H16.881V5.02513C16.881 4.06698 16.1037 3.28961 15.1455 3.28961H13.41V2.1326C13.41 1.49263 12.893 0.975586 12.253 0.975586C11.613 0.975586 11.096 1.49263 11.096 2.1326V3.28961H6.46792V2.1326C6.46792 1.49263 5.95088 0.975586 5.31091 0.975586C4.67094 0.975586 4.1539 1.49263 4.1539 2.1326ZM16.881 7.91766H0.682861V17.7523C0.682861 18.7104 1.46023 19.4878 2.41838 19.4878H15.1455C16.1037 19.4878 16.881 18.7104 16.881 17.7523V7.91766Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.1982,
    height: 18.5122,
    fill: "white",
    transform: "translate(0.682861 0.975586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCalendar);
export default __webpack_public_path__ + "static/media/payment_calendar.e103fa3cf3ad59012341a709c7b71181.svg";
export { ForwardRef as ReactComponent };